// extracted by mini-css-extract-plugin
export default {"confirmRemoveLicenceDialog":"ConfirmRemoveUserMessagesLicence_confirmRemoveLicenceDialog__YV3Bb","buttonGroup":"ConfirmRemoveUserMessagesLicence_buttonGroup__qhhcb"};